fragment CurrencyRateFragment on CurrencyRate {
    id
    currency_code
    rate
}